import { render } from "./D2DRedirect.vue?vue&type=template&id=f73ebf4a&scoped=true"
const script = {}

import "./D2DRedirect.vue?vue&type=style&index=0&id=f73ebf4a&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f73ebf4a"]])

export default __exports__